import "core-js/modules/es.array.concat.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NUDGE_ROUTES } from 'utils/nudges/getNudgePath';
import { hasPrivilege, NUDGE_WRITE } from 'utils/privileges';
import { AdminOrHubButtonLink } from 'components/AdminOrHubLink';
import InlineList from 'components/InlineList';
import TitleCard from 'components/TitleCard';
import NudgesTable from './NudgesTable';
function NudgesOverviewCard(_ref) {
  var contentId = _ref.contentId,
    type = _ref.type,
    variant = _ref.variant;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var nudgesLocation = "".concat(NUDGE_ROUTES.root, "?search=").concat(encodeURIComponent("content:".concat(contentId)));
  if (!hasPrivilege(NUDGE_WRITE)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(TitleCard, {
    title: t('content_type_nudge_plural'),
    sideContent: /*#__PURE__*/React.createElement(InlineList, {
      spacing: "xs"
    }, /*#__PURE__*/React.createElement(AdminOrHubButtonLink, {
      to: nudgesLocation,
      size: "medium"
    }, t('actions_view_all')), /*#__PURE__*/React.createElement(AdminOrHubButtonLink, {
      size: "medium",
      icon: "plus",
      variant: "primary",
      to: "".concat(NUDGE_ROUTES.newContent, "?").concat(type, "Id=").concat(contentId)
    }, t('actions_add_nudge'))),
    description: t('content_nudges_card_description'),
    fontSize: "s",
    variant: variant
  }, /*#__PURE__*/React.createElement(NudgesTable, {
    contentId: contentId,
    type: type
  }));
}
export default NudgesOverviewCard;